import { render, staticRenderFns } from "./providerSwitchIdentity.vue?vue&type=template&id=5286c08c&scoped=true&"
import script from "./providerSwitchIdentity.vue?vue&type=script&lang=babel&"
export * from "./providerSwitchIdentity.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286c08c",
  null
  
)

export default component.exports